import * as t from 'io-ts';

export const ShopInfoSchema = t.type({
  Ref: t.string,
  paypal_client_id: t.string,
  affichage_livechat: t.boolean,
  affichage_offline_livechat: t.boolean,
  affichage_telephone: t.boolean,
  env: t.string,
  idBoutique: t.union([t.string, t.Int]),
  matomo_id: t.union([t.string, t.Int]),
  telephone: t.string,
  trusted_shop_public_api: t.string,
  trusted_shop_tsid: t.boolean,
  trusted_shop_widget_url: t.string,
  newFaqIsEnabled: t.boolean,
  surfaceMin: t.number
});

export type ShopInfo = t.TypeOf<typeof ShopInfoSchema>;
